class d {
  constructor(e) {
    this.editChangeCbs = [], this.editSavedCbs = [], this.registerFieldsCb = null, this.registerFieldsCb = e;
  }
  pushEditChange(e, t, i) {
    this.editChangeCbs.forEach((s) => s(e, t, i));
  }
  pushEditSaved(e) {
    this.editSavedCbs.forEach((t) => t(e));
  }
  registerEditFields(e, t, i, s) {
    this.registerFieldsCb?.(e, t, i, s);
  }
  onEditChange(e) {
    this.editChangeCbs.push(e);
  }
  onEditSaved(e) {
    this.editSavedCbs.push(e);
  }
  connect() {
  }
  destroy() {
  }
  onInit(e) {
  }
  onData(e) {
  }
  onStreamStart(e) {
  }
  onStreamChunk(e) {
  }
  onStreamEnd(e) {
  }
  onThemeConfig(e) {
  }
  saveState(e) {
  }
  emitResize(e) {
  }
  emitAction(e) {
  }
  sendCommand(e) {
  }
}
export {
  d as NativeAdapter
};
